import { Fragment, FC, PropsWithChildren } from 'react';
import { Title, Meta, Link } from 'react-head';

const PageHead: FC<PropsWithChildren> = ({ children }) => {
    return <Fragment>{children}</Fragment>;
};

interface PageDescriptionProps {
    content: string;
    openGraphContent?: string;
}

const PageDescription: FC<PageDescriptionProps & PropsWithChildren> = ({ content, openGraphContent }) => {
    return (
        <Fragment>
            <Meta name="description" content={content} />
            <Meta property="og:description" content={openGraphContent || content} />
        </Fragment>
    );
};

export { PageHead, Title as PageTitle, Meta as PageMeta, PageDescription, Link as PageLink };
